export function matchValue(value) {
  if (!['number', 'string'].includes(typeof value) || String(value).trim() === ''
    || (typeof value === 'number' && !Number.isFinite(value))) return '—';
  return String(value);
}

export function statisticNumber(value) {
  if (!['number', 'string'].includes(typeof value)) return null;
  const text = String(value).trim();
  const match = text.match(/^(-?\d+(?:[.,]\d+)?)\s*%?(?:\s*\(\s*\d+\s*\/\s*\d+\s*\))?$/);
  return match ? Number(match[1].replace(',', '.')) : null;
}

export function matchPlayerName(name) {
  if (!name) return '';
  if (!name.includes(',')) return name.charAt(0).toUpperCase() + name.slice(1);
  const [surname, first = ''] = name.split(',');
  return `${first.trim()} ${surname.trim()}`.toLowerCase()
    .replace(/(^|\s)\S/g, letter => letter.toUpperCase()).trim();
}

export function startingPlayers(players = []) {
  const starters = (Array.isArray(players) ? players : []).filter(player => player.titular === true);
  const ordered = starters.every(player => Number.isInteger(player.ordenAlineacion) && player.ordenAlineacion > 0)
    && new Set(starters.map(player => player.ordenAlineacion)).size === starters.length;
  return ordered ? [...starters].sort((a, b) => a.ordenAlineacion - b.ordenAlineacion) : starters;
}

export function formationPositions(players = [], system, away = false) {
  const text = String(system ?? '').trim();
  if (!/^\d{1,2}(?:\s*[-:]\s*\d{1,2}){1,5}$/.test(text)) return null;
  const lines = text.split(/\s*[-:]\s*/).map(Number);
  if (lines.some(count => count <= 0) || lines.reduce((sum, count) => sum + count, 0) !== 10) return null;
  const starters = startingPlayers(players);
  if (starters.length !== 11) return null;
  const orders = starters.map(player => player.ordenAlineacion);
  if (orders.some(order => order !== undefined)
    && !orders.every((order, index) => order === index + 1)) return null;
  const keepers = starters.filter(player => player.portero === true || ['Portero', 'GK'].includes(player.posicion));
  if (keepers.length !== 1 || keepers[0] !== starters[0]) return null;
  let index = 0;
  return [1, ...lines].flatMap((count, line) => Array.from({ length: count }, (_, row) => {
    const x = 6 + line / lines.length * 38;
    return { player: starters[index++], line, x: away ? 100 - x : x, y: 100 - (row + 1) / (count + 1) * 100 };
  }));
}

export function playerMetricColumns(statistics) {
  const players = statistics?.jugadores || [];
  const catalog = statistics?.catalogoMetricas || statistics || {};
  const types = new Map([...(statistics?.metricasDerivadas || []), ...(catalog.tiposMetricas || [])]
    .map(type => [type.id, type]));
  const ids = [...new Set(players.flatMap(player => Object.keys(player.estadisticas || {})))];
  return ids.map(id => ({
    id,
    label: types.get(id)?.label || players.find(player => player.estadisticas?.[id]?.nombre)?.estadisticas[id].nombre || id,
    description: types.get(id)?.description || '',
    sort: types.get(id)?.defaultSort || 'DESC',
    format: types.get(id)?.valueFormatPatternWeb,
  }));
}

export function playerMetricValue(player, column) {
  const raw = matchValue(player.estadisticas?.[column.id]?.valor);
  const pattern = column.format;
  const text = pattern?.stringFormatPattern;
  const ids = pattern?.replaceData;
  if (typeof text !== 'string' || !Array.isArray(ids) || !ids.length
    || !ids.every(id => typeof id === 'string') || (text.match(/%s/g) || []).length !== ids.length
    || !ids.some(id => matchValue(player.estadisticas?.[id]?.valor) !== '—')) return raw;
  let index = 0;
  return text.replace(/%s/g, () => matchValue(player.estadisticas?.[ids[index++]]?.valor));
}
